import React from "react";
import OrderList from "./OrderList";

function Delivered({ status }) {
  return <OrderList status={status} />;
}

export default Delivered;
